module.exports = __webpack_public_path__ + "static/media/9-item-a.b21dfff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/9-item-a.jpg
// module id = 472
// module chunks = 33